import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Injectable } from "@angular/core";
import "rxjs/Rx";
import { NzMessageService } from "ng-zorro-antd";

import { GetSessionStore, Cookies } from "./comment";
@Injectable()
export class HttpBaseService {
  constructor(private http: HttpClient, private msg: NzMessageService) { }
  /**
   * @param {string} url地址
   * @param {any} [params]可选提交的参数
   * @param {any} [header]可选设置的头信息
   * @memberof ServiceBaseService
   * @title: 封装一个get请求的基础类
   */
  get(url: string, params?: any, myheaders?: any): Observable<any> {
    // 配置请求头
    const myHeaders: HttpHeaders = new HttpHeaders();
    // tslint:disable-next-line:forin
    for (const key in myheaders) {
      myHeaders.append(key, myheaders[key]);
    }
    url += (url.indexOf("?") < 0 ? "?" : "&") + this.param(params);
    return this.http.get(url, { headers: myHeaders }).map(res => res);
  }

  /**
   * @param url地址
   * @param options提交的数据
   * @param headers
   * @title:封装一个post请求数据的
   */
  post(url: string, params: any, headers?: any, timeout?: boolean): Observable<any> {
    // let headers = new HttpHeaders()
    // .set('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8')
    let h = {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
    };
    let successLoginInfo = JSON.parse(GetSessionStore("successLoginInfo"));

    if (headers) {
      h = Object.assign(headers, h);
    } else if (successLoginInfo) {
      headers = {
        certificate: successLoginInfo.certificate
      };
      h = Object.assign(headers, h);
    }

    let myheaders = new HttpHeaders(h);
    let p = this.transformRequest(params);
    return this.http.post(url, p, { headers: myheaders }).map((res: any) => {
      let sessionTime = 30; // 系统会话时长
      if (timeout !== false) {
        Cookies.setCookie('sessionTime', 'running', sessionTime); // 系统会话时长
      }
      return res;
    });
  }

  login(url: string, params: any, headers?: any): Promise<any> {
    // let headers = new HttpHeaders()
    // .set('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8')
    let h = {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
    };
    if (headers) {
      h = Object.assign(headers, h);
    }
    let myheaders = new HttpHeaders(h);
    let p = this.transformRequest(params);
    return this.http
      .post(url, p, { headers: myheaders })
      .toPromise()
      .then(res => {
        if (res["status"] === "E") {
          // this.msg.error(res["msg"]);
        }
        return res;
      });
  }
  /**
   * @param {any} data
   * @returns
   * @memberof ServiceBaseService
   * @title:封装一个序列化get请求的参数的方法
   */
  param(data): string {
    let url = "";
    // tslint:disable-next-line:forin
    for (const k in data) {
      const value = data[k] !== undefined ? data[k] : "";
      url += `&${k}=${encodeURIComponent(value)}`;
    }
    return url ? url.substring(1) : "";
  }

  // 请求参数 转换为form data
  transformRequest(obj): string {
    let s = "";
    if (JSON.stringify(obj) === "{}") {
      return "";
    }
    for (let n in obj) {
      s += `&${encodeURIComponent(n)}=${encodeURIComponent(obj[n])}`;
    }
    return s.substr(1);
  }
}



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/services/httpBase.service.ts